import React from 'react'

import { Html } from '@application/Interfaces/Atoms/Html'
import type { HeroProfileComponentType } from '@application/Types/ComponentTypes'
import { Nullable } from '@application/Types/Opt'
import { parseUtmParamsInHtml } from '@src/Application/Utils/generalUtils'

import { Description } from './HeroDescription.styled'

export const HeroDescription = ({
    description,
    mode,
}: Pick<HeroProfileComponentType, 'description' | 'mode'>): Nullable<JSX.Element> => {
    return description ? (
        <Description $mode={mode}>
            <Html content={parseUtmParamsInHtml(description.data.childMarkdownRemark.html)} />
        </Description>
    ) : null
}
